import { render, staticRenderFns } from "./DealCardMenu.vue?vue&type=template&id=e472c65c&scoped=true"
import script from "./DealCardMenu.vue?vue&type=script&lang=js"
export * from "./DealCardMenu.vue?vue&type=script&lang=js"
import style0 from "./DealCardMenu.vue?vue&type=style&index=0&id=e472c65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e472c65c",
  null
  
)

export default component.exports